import { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Table, Badge, Button, Modal } from 'react-bootstrap'
import { humanizeDate } from '../../Utils/Dates/Dates'
import { cleanAdmin, getAdminDetail } from '../api/api'
import toast from 'react-hot-toast'

export const AdminDetail = ({ adminId, setSelectedAdmin }) => {
    const [activeTab, setActiveTab] = useState('general')
    const [admin, setAdmin] = useState(null)
    const [showCleanSessionModal, setShowCleanSessionModal] = useState(false)
    const [loadingCleanSession, setLoadingCleanSession] = useState(false)
    useEffect(() => {
        if (adminId) {
            getAdminDetail(adminId).then((res) => {
                setAdmin(res)
            })
        }
    }, [adminId])

    if (!admin) {
        return (
            <div className="text-center p-5">
                <h3>Select an administrator to view details</h3>
            </div>
        )
    }

    const handleShowCleanSessionModal = () => {
        setShowCleanSessionModal(true)
    }

    const handleCleanSession = async () => {
        setLoadingCleanSession(true)
        const res = await cleanAdmin(admin.name)
        if (res) {
            toast.success('Sesión limpiada correctamente')
            setShowCleanSessionModal(false)
        }
        setLoadingCleanSession(false)
    }

    return (
        <>
            {showCleanSessionModal && (
                <Modal show={showCleanSessionModal} onHide={() => setShowCleanSessionModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Limpiar Sesión</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="text-center">
                            <p>
                                <strong>Se pedirán nuevos token de acceso para el administrador.</strong>
                                <br />
                                <br />
                                <span className="text-warning">Antes de hacerlo, informa al administrador que pause sus operaciones unos segundos, para evitar fallos de conexión.</span>
                            </p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowCleanSessionModal(false)}>Cancelar</Button>
                        <Button variant="danger"
                            onClick={() => handleCleanSession(adminId)}
                            disabled={loadingCleanSession}>
                            {loadingCleanSession ? 'Limpiando sesión...' : 'Limpiar Sesión'}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            <Container fluid className="py-4 w-75">
                <div className="d-flex justify-content-start mb-4">
                    <Button variant="primary" onClick={() => setSelectedAdmin(null)}>Volver</Button>
                </div>

                <Card className="shadow-sm">
                    <Card.Header className="bg-primaryy text-white">
                        <h3 className="mb-0">{admin.name} - Detalles del Administrador</h3>
                    </Card.Header>
                    <Card.Body>
                        <Row className="mb-4">
                            <Col md={3}>
                                <div className="d-flex flex-column">
                                    <Button
                                        variant={activeTab === 'general' ? 'primary' : 'outline-primary'}
                                        className="text-start mb-2"
                                        onClick={() => setActiveTab('general')}
                                    >
                                        Información General
                                    </Button>
                                    <Button
                                        variant={activeTab === 'platform' ? 'primary' : 'outline-primary'}
                                        className="text-start mb-2"
                                        onClick={() => setActiveTab('platform')}
                                    >
                                        Configuración del Bot
                                    </Button>
                                </div>
                            </Col>
                            <Col md={9}>
                                {activeTab === 'general' && (
                                    <Card>
                                        <Card.Body>
                                            <h4 className="mb-3">Información General</h4>
                                            <Table bordered hover responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="fw-bold" width="30%">Nombre</td>
                                                        <td>{admin.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Usuario de Plataforma</td>
                                                        <td>{admin.nickname}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Plataforma</td>
                                                        <td>
                                                            <Badge bg="info">{admin.platform}</Badge>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">URL del Gestor</td>
                                                        <td>
                                                            <a href={admin.gestorUrl} target="_blank" rel="noopener noreferrer">
                                                                {admin.gestorUrl}
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Última Actividad</td>
                                                        <td>{humanizeDate(admin.lastActivity)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Fecha de Creación</td>
                                                        <td>{humanizeDate(admin.createdAt)}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                )}

                                {activeTab === 'platform' && (
                                    <Card>
                                        <Card.Body>
                                            <h4 className="mb-3">Configuración del Bot</h4>
                                            <Table bordered hover responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="fw-bold" width="30%">Contraseña Predeterminada</td>
                                                        <td>{admin.default_users_password || 'No establecida'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Enlace de Página</td>
                                                        <td>{admin.pageLink || 'No establecido'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Valor Máximo de Carga</td>
                                                        <td>{admin.maxLoadValue || 'No establecido'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Usar Valor Máximo de Carga</td>
                                                        <td>
                                                            <Badge bg={admin.useMaxLoadValue ? 'success' : 'secondary'}>
                                                                {admin.useMaxLoadValue ? 'Sí' : 'No'}
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Mostrar Saldo</td>
                                                        <td>
                                                            <Badge bg={admin.showBalance ? 'success' : 'secondary'}>
                                                                {admin.showBalance ? 'Sí' : 'No'}
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold">Actualmente En Promoción</td>
                                                        <td>
                                                            <Badge bg={admin.currentlyInPromo ? 'success' : 'secondary'}>
                                                                {admin.currentlyInPromo ? 'Sí' : 'No'}
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                )}

                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col md={12}>
                                <Button variant="danger" onClick={() => handleShowCleanSessionModal(adminId)} disabled={loadingCleanSession}>
                                    {loadingCleanSession ? 'Limpiando sesión...' : 'Limpiar Sesión'}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}
